export default __webpack_public_path__ + "images/39_thumbnail.jpg";